import { render, staticRenderFns } from "./ClusterList.vue?vue&type=template&id=0c96f33e&scoped=true&"
import script from "./ClusterList.vue?vue&type=script&lang=js&"
export * from "./ClusterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96f33e",
  null
  
)

export default component.exports